import client from './client';

export const stripeConnectApi = {
  getStatus() {
    return client.get('/stripe-connect/status');
  },
  createOnboardLink() {
    return client.post('/stripe-connect/onboard-link');
  },
  createDashboardLink() {
    return client.post('/stripe-connect/dashboard-link');
  },
};

